import { render, staticRenderFns } from "./DashboardGrafik.vue?vue&type=template&id=cbce4b84&scoped=true&"
import script from "./DashboardGrafik.vue?vue&type=script&lang=js&"
export * from "./DashboardGrafik.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGrafik.vue?vue&type=style&index=0&id=cbce4b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbce4b84",
  null
  
)

export default component.exports